<template>
    <framework>
        <template #side>
            <side-panel-nav/>
        </template>
        <template #main>
            <main-header title="Dashboard" icon="fa-home"/>

            <div class="start fadeIn">
                <div class="welcome">
                    <h1><strong>{{ welcome }},</strong> {{ currentUser.first_name }}</h1>
                    <h3>What can we help you with today?</h3>
                </div>

                <dashboard-banners/>

                <attention-list v-if="showAttention" :items="attentionItems" :loading="!dashboardFeed && dashboardLoading" class="mb-6"/>

                <div class="columns is-variable is-5">
                    <div class="column is-8-desktop">
                        <getting-started v-if="isEmpty" class="mb-6"/>
                        <continue-section v-else-if="showContinue" class="mb-6"/>
                        <conference-section class="mb-6"/>
                        <pd-section v-if="dashboardPd" class="mb-6"/>
                    </div>
                    <div class="column is-4-desktop">
                        <study-activity-mini class="mb-6"/>
                        <payment-plan-panel class="mb-6"/>
                    </div>
                </div>
            </div>
        </template>
    </framework>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import MainHeader from "../../components/framework/MainHeader";
    import Framework from "../../components/framework/Framework";
    import SidePanelNav from "../../components/framework/SidePanelNav";
    import DashboardBanners from "../../components/dashboard/DashboardBanners";
    import GettingStarted from "../../components/dashboard/GettingStarted";
    import AttentionList from "../../components/dashboard/AttentionList";
    import ContinueSection from "../../components/dashboard/ContinueSection";
    import ConferenceSection from "../../components/dashboard/ConferenceSection";
    import PaymentPlanPanel from "../../components/dashboard/PaymentPlanPanel";
    import StudyActivityMini from "../../components/dashboard/StudyActivityMini";
    import PdSection from "../../components/dashboard/PdSection";

    export default {
        components: {
            Framework, SidePanelNav, MainHeader, DashboardBanners, GettingStarted, AttentionList,
            ContinueSection, ConferenceSection, PaymentPlanPanel, StudyActivityMini, PdSection,
        },
        computed: {
            ...mapGetters(['currentUser', 'enrollments', 'registrations', 'dashboardFeed', 'dashboardLoading', 'attentionItems', 'activeEnrollmentCount', 'continueEnrollments', 'dashboardPd']),
            welcome: function() {
                const currentHour = new Date().getHours();
                return currentHour >= 4 && currentHour < 12 ? 'Good morning' :
                    currentHour >= 12 && currentHour <= 17 ? 'Good afternoon' :
                        currentHour > 17 || currentHour < 4 ? 'Good evening' : 'Welcome';
            },
            loaded() {
                return Array.isArray(this.enrollments) && Array.isArray(this.registrations);
            },
            isEmpty() {
                return this.loaded && this.enrollments.length === 0 && this.registrations.length === 0;
            },
            // Skeleton while loading; afterwards only when there is an
            // active course to continue (no "nothing in progress" filler)
            showContinue() {
                return !this.loaded || this.continueEnrollments.length > 0;
            },
            // Only when there is something in it — no "all caught up" filler
            showAttention() {
                return this.attentionItems.length > 0;
            }
        },
        mounted() {
            if (!localStorage.getItem('token')) this.$router.push('/');
            // Everything fresh on every visit — this is the landing page after
            // signing at TPO, checking out, or finishing a course
            this.getBillingState();
            this.getEnrollments();
            this.getRegistrations();
            this.getDashboard().catch(() => {});
        },
        methods: {
            ...mapActions(['getBillingState', 'getEnrollments', 'getRegistrations', 'getDashboard']),
        }
    };
</script>

<style lang="scss" scoped>
    .start {
        display: flex;
        flex-direction: column;

        transition-delay: 0ms;
        transition-duration: 500ms;

        .welcome {
            color: white;
            margin: 3rem 0;

            h1 {
                font-size: 2.5rem;
                color: #ffffff;

                strong {
                    color: #ffffff;
                }
            }

            h3 {
                font-size: 1.2rem;
                color: rgba(255, 255, 255, 0.7);
            }

            @media (max-width: 600px) {
                margin: 1rem 0 2rem;

                h1 {
                    font-size: 1.7rem;
                }
                h3 {
                    font-size: 1rem;
                }
            }
        }
    }
</style>
